import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';

export const enum CTAInteractionType {
  REPLY_WITH_VIDEO = 'Reply with video',
  NEW_INVENTORY = 'New Inventory',
  USED_INVENTORY = 'Used Inventory',
  GET_PRE_APPROVED = 'Get Pre-Approved',
  SCHEDULE_SERVICE = 'Schedule Service',
  EMAIL_CLICK = 'Email Click',
}

export function trackCTAInteractionEvent({
  type,
}: {
  type: CTAInteractionType;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.CTA_INTERACTION,
  };

  pushToDataLayer({
    ...eventAttributes,
    type,
  });
}
